module.exports = __webpack_public_path__ + "img/warning_b.dc624e63.svg";